const supportTypes = [
    { name: "AccessAuditing", label: `Archwilio mynediad` },
    { name: "AudioDescription", label: `Disgrifiadau Sain` },
    { name: "Braille", label: `Braille` },
    { name: "BritishSignLanguage", label: `Iaith Arwyddion Prydain` },
    { name: "Captioning", label: `Capsiynau` },
    { name: "Coaching", label: `Hyfforddi` },
    { name: "Consultancy", label: `Ymgynghoriaeth` },
    { name: "EasyRead", label: `Hawdd ei Ddeall` },
    { name: "InterpretationProvider", label: `Darparwr Dehongli` },
    { name: "IrishSignLanguage", label: `Iaith Arwyddion Iwerddon` },
    { name: "KnowledgeBase", label: `Sylfaen Wybodaeth` },
    { name: "Makaton", label: `Makaton` },
    { name: "Marketing", label: `Marchnata` },
    { name: "Mentoring", label: `Mentora` },
    { name: "SupportLine", label: `Llinell Gymorth` },
    { name: "SignSupportedEnglish", label: `Saesneg \u00E2 Chymorth Iaith Arwyddion` },
    { name: "Software", label: `Meddalwedd` },
    { name: "Streaming", label: `Ffrydio` },
    { name: "Training", label: `Hyfforddiant` },
    { name: "UsabilityTesting", label: `Profi Defnyddioldeb` }
];
const operationIn = [
    { name: "England", label: `Lloegr` },
    { name: "Scotland", label: `Yr Alban` },
    { name: "Wales", label: `Cymru` },
    { name: "NorthernIreland", label: `Gogledd Iwerddon` },
    { name: "Ireland", label: `Iwerddon` },
    { name: "Online", label: `Ar-lein` }
];
const artforms = [
    { name: "CombinedArts", label: `Celfyddydau Cyfun` },
    { name: "Craft", label: `Crefftau` },
    { name: "Dance", label: `Dawns` },
    { name: "Festivals", label: `G\u0175yl` },
    { name: "FilmOrScreen", label: `Ffilm/Sgrin` },
    { name: "Libraries", label: `Llyfrgelloedd` },
    { name: "Literature", label: `Llenyddiaeth` },
    { name: "Museums", label: `Amgueddfeydd` },
    { name: "Music", label: `Cerddoriaeth` },
    { name: "PerformingArts", label: `Celfyddydau Perfformio` },
    { name: "Theatre", label: `Theatr` },
    { name: "VisualArts", label: `Celfyddydau Gweledol` },
];
const languages = [
    { name: 'en', label: 'English' },
    { name: 'cy', label: 'Cymraeg' },
    // {name: 'ga', label: 'Gaeilge'},
    { name: 'gd', label: 'Gaelic' }
];
const processProfileData = (_profileData, support_org_language_texts) => {
    //console.log('processProfileData', _profileData);
    if (_profileData?.draftInfo) {
        let draftInfo = JSON.parse(_profileData.draftInfo);
        _profileData = { ..._profileData, ...draftInfo };
    }
    let returnData = [
        { name: 'logo', type: 'file', title: `Logo`, value: '', description: ``, error_message: `Lanlwythwch logo ar gyfer eich proffil Cymorth` },
        { name: 'name', type: 'text', title: `Enw`, value: _profileData?.name, 'required': true, description: ``, error_message: `Rhowch enw eich proffil Cymorth ` },
        //{name:'language', type:'select', title:msg(`What is the language of your organisation?`), value:_profileData?.language, 'required':true, options:languages, description:msg(str`What language will you be submitting this profile in?`), error_message:msg(str`Please select the language for your Support profile`)},
        { name: 'language', type: 'select', title: support_org_language_texts?.support_org_language || `Beth yw enw eich sefydliad?`, value: _profileData?.language, 'required': true, options: languages, description: support_org_language_texts?.support_org_language_description || `Ym mha iaith fyddwch chi\u2019n cyflwyno\u2019r proffil hwn?`, error_message: support_org_language_texts?.support_org_language_error || `Dewiswch yr iaith ar gyfer eich proffil Cymorth ` },
        { name: 'description', type: 'textarea', title: `Disgrifiad`, value: _profileData?.description, 'required': true, description: ``, error_message: `Rhowch ddisgrifiad o'ch proffil Cymorth ` },
        { name: 'website', type: 'url', title: `Gwefan`, value: _profileData?.website, description: ``, error_message: `Rhowch y wefan ar gyfer eich proffil Cymorth` },
        { name: 'email', type: 'email', title: `E-bost`, value: _profileData?.email, description: ``, error_message: `Rhowch y cyfeiriad e-bost ar gyfer eich proffil Cymorth` },
        { name: 'phone', type: 'text', title: `Ff\u00F4n`, value: _profileData?.phone, description: ``, error_message: `Rhowch y rhif ff\u00F4n ar gyfer eich proffil Cymorth` },
        { name: 'operationIn', type: 'multiselect', title: `Meysydd gweithredu`, value: _profileData?.operationIn, options: operationIn, description: ``, error_message: `Dewiswch y meysydd y mae eich proffil Cymorth yn gweithredu ynddynt` },
        { name: 'supportTypes', type: 'multiselect', title: `Y mathau o gymorth a gynigir`, value: _profileData?.supportTypes, options: supportTypes, description: ``, error_message: `Dewiswch y mathau o gymorth a gynigir gan eich proffil Cymorth` },
        { name: 'artforms', type: 'multiselect', title: `Ffurfiau celfyddydol a gefnogir`, value: _profileData?.artforms, options: artforms, description: ``, error_message: `Dewiswch y ffurfiau celfyddydol a gefnogir gan eich proffil Cymorth` },
    ];
    //console.log('returnData', returnData);
    return returnData;
};
export { supportTypes, operationIn, artforms, processProfileData };
